import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import {
    IMAGE_ENHANCER_USE_CREDIT,
    setSliceImageEnhancerCreationListAction,
    setSliceSelectCreationIdAction,
    setSliceUploadImageListAction,
} from '../slices/FJSliceImageEnhancer';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import FJImageStore from '../../store/FJImageStore';
import FJConstant from '../../constants/FJConstant';
import {
    MAX_COMPRESS_IMAGE_SIZE,
    MAX_POLLING_ERROR_TIME,
    TASK_POLLING_INTERVAL,
} from '../../config/dataConfig/FJGenerateData';
import {
    setSelectedDownloadList,
    setSliceBatchDownloadLoadingAction,
    setSliceTaskStatusAction,
} from '../slices/FJSliceCommon';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';
const MAX_FILE_NUM = 10;
let f_eventIdList = [];
let f_buryData = null;
let f_startGenerateTime = null;

const _imageEnhancer = async (data, dispatch) => {
    const idInfo = await FJNetworkStore.imageEnhancer(data);
    const { code, data: dataInfo } = idInfo;
    if (code === 401) {
        dispatch(FJActionModal.showUpgradeModalAction());
        return;
    } else if (code === 214) {
        FJUtil.login();
        return;
    }
    const eventId = dataInfo?.event_id;
    if (!eventId) {
        throw new Error('create task error');
    }
    return eventId;
};
const _addErrorMessage = (number = 0) => {
    const isMobile = FJUtil.isMobile();
    const message = isMobile
        ? FJLocalStore._('failed-to-generate-the-image-please-try-it-again')
        : FJLocalStore._('images-failed-to-be-generated-in-the-current-task').replace('xxx', number);
    FJMessageStore.addMessage(message, 'error');
};
const FJActionImageEnhancer = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageListAction([]));
            dispatch(setSliceImageEnhancerCreationListAction([]));
            // dispatch(setSliceZoomAction(2));
        };
    },
    uploadImagesAction: function (files) {
        return async (dispatch, getState) => {
            if (!files.length) return;
            const { uploadImageList } = getState().imageEnhancer;
            const { taskStatus } = getState().common;
            const isMobile = FJUtil.isMobile();
            let errorCount = 0;
            let isOverLimit = false;
            let sameFileCount = 0;
            if (FJUtil.isGeneratingStatus(taskStatus)) {
                return;
            }
            if (uploadImageList.length >= MAX_FILE_NUM) {
                isOverLimit = true;
            } else {
                let fileNum = Math.min(MAX_FILE_NUM - uploadImageList.length, files.length);
                const __fileError = () => {
                    errorCount++;
                    fileNum++;
                };
                for (let i = 0; i < fileNum; i++) {
                    const file = files[i];
                    if (!file) break;
                    try {
                        const isImage = FJUtil.isImage(file);
                        if (isImage) {
                            const list = getState().imageEnhancer.uploadImageList;
                            const fileId = await FJUtil.hashEncode(file);
                            const sameFile = list.find(item => item.fileId === fileId);
                            if (sameFile) {
                                sameFileCount++;
                                fileNum++;
                                continue;
                            }
                            const data = await FJCompressedImageStore.compressImageByFile(file);

                            if (data) {
                                const info = {
                                    ...data,
                                    currentQueue: 0,
                                    queueNumber: 0,
                                    taskStatus: FJConstant.DEFAULT,
                                    fileId,
                                };
                                if (isMobile) {
                                    //单张上传
                                    dispatch(setSliceUploadImageListAction([info]));
                                } else {
                                    dispatch(setSliceUploadImageListAction([info, ...list]));
                                }
                            } else {
                                __fileError();
                            }
                        } else {
                            __fileError();
                        }
                    } catch (error) {
                        __fileError();
                    }
                }
                isOverLimit = files.length > fileNum;
            }
            sameFileCount &&
                FJMessageStore.addMessage(FJLocalStore._('file-already-exists-please-select-other-files'), 'error');
            isOverLimit &&
                FJMessageStore.addMessage(
                    FJLocalStore._('the-10-image-limit-for-batch-generation-has-been-reached'),
                    'error',
                );
            errorCount &&
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-detected-please-upload-images-in-png-jpg-etc'),
                    'error',
                );
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async (dispatch, getState) => {
            const { size, name, id, stop, success, fail } = options;
            const { taskStatus } = getState().common;
            if (FJUtil.isGeneratingStatus(taskStatus)) {
                return;
            }
            const { uploadImageList } = getState().imageEnhancer;
            const sameFile = uploadImageList.find(item => item.fileId === id);
            if (sameFile) {
                // TODO 重复的图片
                FJMessageStore.addMessage(FJLocalStore._('file-already-exists-please-select-other-files'), 'error');
                if (fail) fail();
                return;
            }

            if (uploadImageList.length >= MAX_FILE_NUM) {
                FJMessageStore.addMessage(
                    FJLocalStore._('the-10-image-limit-for-batch-generation-has-been-reached'),
                    'error',
                );
                if (stop) stop();
                return;
            }

            let data;
            if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            const info = {
                ...data,
                currentQueue: 0,
                queueNumber: 0,
                taskStatus: FJConstant.DEFAULT,
                fileId: id,
            };
            const newList = [...uploadImageList];
            newList.unshift(info);
            dispatch(setSliceUploadImageListAction(newList));
            if (success) success();
        };
    },
    deleteImageFile: function (item) {
        return async (dispatch, getState) => {
            const { uploadImageList, imageEnhancerCreationList, selectCreationId } = getState().imageEnhancer;

            const { id, taskStatus, eventId } = item;
            if (FJUtil.isGeneratingStatus(taskStatus)) {
                if (taskStatus === FJConstant.START) {
                    FJMessageStore.addMessage(FJLocalStore._('cant-stop-now-please-try-again-later'), 'error');
                    return;
                } else {
                    try {
                        await FJNetworkStore.cancelTask(eventId);
                    } catch (e) {
                        FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
                        return;
                    }
                }
            }

            const newImageList = uploadImageList.filter(i => i.id !== id);
            const newCreationList = imageEnhancerCreationList.filter(i => i.id !== id);
            if (selectCreationId === id) {
                const newSelectId = newCreationList[0]?.id || '';
                dispatch(setSliceSelectCreationIdAction(newSelectId));
            }
            dispatch(setSliceUploadImageListAction(newImageList));
            dispatch(setSliceImageEnhancerCreationListAction(newCreationList));
            if (!newImageList.length) {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    updateImageListTaskStatus: function (taskStatus = FJConstant.DEFAULT, ids = []) {
        return async (dispatch, getState) => {
            const { uploadImageList } = getState().imageEnhancer;
            let newImageList = [];
            if (ids && ids.length) {
                newImageList = uploadImageList.map(item => {
                    if (ids.includes(item.id)) {
                        // item.taskStatus = taskStatus;
                        return { ...item, taskStatus };
                    }
                    return item;
                });
            } else {
                newImageList = uploadImageList.map(item => ({ ...item, taskStatus }));
            }
            dispatch(setSliceUploadImageListAction(newImageList));
        };
    },
    generateAction: function () {
        return async (dispatch, getState) => {
            const { uploadImageList, upscale } = getState().imageEnhancer;
            dispatch(this._imageEnhancerAction({ uploadImageList, upscale }));
        };
    },
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { imageEnhancerCreationList } = getState().imageEnhancer;
            const item = imageEnhancerCreationList.find(item => item.id === id);
            if (item) {
                dispatch(this._imageEnhancerAction(item.generateInfo));
            }
        };
    },
    _imageEnhancerAction: function (options) {
        return async (dispatch, getState) => {
            const isMobile = FJUtil.isMobile();
            const { uploadImageList, upscale: factor } = options;
            let { creditNumber, freeNumCreation } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;
            f_startGenerateTime = new Date().getTime();

            f_buryData = {
                number: uploadImageList.length,
                'upscaler size': factor,
            };
            FJUtil.eaLog('image upscaler generate click', f_buryData);
            const __errorAndClear = (hasMessage = true) => {
                dispatch(setSliceImageEnhancerCreationListAction([]));
                dispatch(setSelectedDownloadList([]));
                dispatch(FJActionImageEnhancer.updateImageListTaskStatus(FJConstant.DEFAULT));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                if (hasMessage) {
                    _addErrorMessage(uploadImageList.length);
                }
            };
            //1.判断是否上传图片
            if (!uploadImageList.length) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }
            //2.开始状态修改

            const placeHolderList = uploadImageList.map(item => ({
                id: item.id,
                width: item.width,
                height: item.height,
                imgUrl: '',
                taskStatus: FJConstant.START,
                eventId: '',
                isLoading: true,
                isReload: false,
                originalUrl: '',
                generateInfo: { upscale: factor, uploadImageList },
            }));
            dispatch(setSliceSelectCreationIdAction(placeHolderList[0].id));
            dispatch(setSliceImageEnhancerCreationListAction(placeHolderList));
            dispatch(
                FJActionImageEnhancer.updateImageListTaskStatus(
                    FJConstant.START,
                    uploadImageList.map(item => item.id),
                ),
            );
            if (isMobile) {
                //单张
                dispatch(setSliceTaskStatusAction(FJConstant.START));
            } else {
                dispatch(setSliceTaskStatusAction(FJConstant.GENERATING));
            }
            //3.判断登陆

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    _addErrorMessage(uploadImageList.length);
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __errorAndClear(false);
                return;
            }
            //4.额度判断
            const isExceedCredits = uploadImageList.length * IMAGE_ENHANCER_USE_CREDIT > creditNumber;
            if (isExceedCredits && ((uploadImageList.length > 1 && hasFreeCreation) || !hasFreeCreation)) {
                dispatch(FJActionModal.showUpgradeModalAction());
                __errorAndClear(false);
                return;
            }
            const isFree = isExceedCredits && hasFreeCreation;
            try {
                //4.上传s3
                const urlList = uploadImageList.map(i => i.src);
                const imageS3UrlList = await FJImageStore.uploadFilesByUrl(urlList);
                if (!imageS3UrlList) {
                    __errorAndClear(true);
                    return;
                }
                const params = {
                    image: imageS3UrlList.toString(),
                    factor,
                };
                const eventIdList = await _imageEnhancer(params);
                if (!eventIdList) {
                    __errorAndClear(true);
                    return;
                }
                FJUtil.updateAllCreditInfo();

                const list = getState().imageEnhancer.uploadImageList;
                const generateList = uploadImageList.map((item, idx) => ({ ...item, eventId: eventIdList[idx] }));
                const newList = list.map(item => {
                    const generateInfo = generateList.find(i => i.id === item.id);
                    if (generateInfo) {
                        return { ...item, eventId: generateInfo.eventId };
                    } else {
                        return item;
                    }
                });
                dispatch(setSliceUploadImageListAction(newList));
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                //5.轮询任务状态

                dispatch(FJActionImageEnhancer.pollingTaskListAction(eventIdList, isFree));
            } catch (error) {
                dispatch(FJActionImageEnhancer._errorAndReLoadAction());
            }
        };
    },
    _errorAndReLoadAction: function () {
        //重试，移动端
        return (dispatch, getState) => {
            const creationList = getState().imageEnhancer.imageEnhancerCreationList;
            const reLoadList = creationList.map(i => ({
                ...i,
                isLoading: false,
                isReload: true,
            }));
            dispatch(setSliceImageEnhancerCreationListAction(reLoadList));
            dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
            _addErrorMessage();
        };
    },
    updateImageInfoById: function (id, options = {}) {
        return (dispatch, getState) => {
            const { uploadImageList } = getState().imageEnhancer;
            const list = JSON.parse(JSON.stringify(uploadImageList));
            const item = list.find(i => i.id === id);
            if (!item) return;
            Object.keys(options).forEach(key => {
                options[key] !== undefined && (item[key] = options[key]);
            });
            dispatch(setSliceUploadImageListAction(list));
        };
    },
    updateCreationInfoById: function (id, options = {}) {
        return (dispatch, getState) => {
            const { imageEnhancerCreationList } = getState().imageEnhancer;
            const list = JSON.parse(JSON.stringify(imageEnhancerCreationList));
            const item = list.find(i => i.id === id);
            if (!item) return;
            Object.keys(options).forEach(key => {
                options[key] !== undefined && (item[key] = options[key]);
            });
            dispatch(setSliceImageEnhancerCreationListAction(list));
            const isLoading = list.filter(i => i.isLoading).length !== 0;
            const isDone = list.length > 0 && !isLoading;
            if (isDone) dispatch(setSelectedDownloadList(list));
        };
    },
    deleteImageById: function (id) {
        return (dispatch, getState) => {
            const { uploadImageList } = getState().imageEnhancer;
            const newImageList = uploadImageList.filter(i => i.id !== id);
            dispatch(setSliceUploadImageListAction(newImageList));
        };
    },
    deleteCreationById: function (id) {
        return (dispatch, getState) => {
            const { imageEnhancerCreationList = [], selectCreationId } = getState().imageEnhancer;
            const newCreationList = imageEnhancerCreationList.filter(i => i.id !== id);
            if (selectCreationId === id) {
                const idx = Math.max(imageEnhancerCreationList.findIndex(i => i.id === id) - 1, 0);
                const newSelectId = newCreationList[idx]?.id || '';
                dispatch(setSliceSelectCreationIdAction(newSelectId));
            }
            dispatch(setSliceImageEnhancerCreationListAction(newCreationList));
        };
    },
    pollingTaskListAction: function (list, isFree) {
        const isMobile = FJUtil.isMobile();
        f_eventIdList = [...list];
        let timer = null;
        let errorTime = 0;
        let failTaskCount = 0;

        return async (dispatch, getState) => {
            const { uploadImageList } = getState().imageEnhancer;
            const _error = () => {
                !isMobile && dispatch(FJActionImageEnhancer.generateErrorAction());
                _complete();
                clearTimeout(timer);
                timer = null;
            };
            const _complete = () => {
                //任务结束
                if (failTaskCount) {
                    if (isMobile) {
                        dispatch(FJActionImageEnhancer._errorAndReLoadAction());
                    } else {
                        _addErrorMessage(failTaskCount);
                        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    }
                } else if (!isMobile) {
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                }
                let endTime = new Date().getTime();
                const generatingDuration = FJUtil.getTimeDiff(f_startGenerateTime, endTime);
                generatingDuration && (f_buryData['queuing duration'] = generatingDuration);
                f_buryData.number = f_buryData.number - failTaskCount;
                FJUtil.eaLog('image upscaler generate success', f_buryData);
                FJUtil.eaLog('ai tool generate success', {
                    tool: FJUtil.getToolName(),
                    'credit&free': isFree ? 'free' : 'credit',
                });
            };
            const _request = async () => {
                try {
                    if (f_eventIdList.length == 0) {
                        _complete();
                        return;
                    }
                    const result = await FJNetworkStore.getTaskState(f_eventIdList.join(','));
                    if (f_eventIdList.length == 0) {
                        // 取消任务
                        return;
                    }
                    let data = result;

                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            failTaskCount = f_eventIdList.length;
                            _error();
                        } else {
                            timer = setTimeout(_request.bind(null, f_eventIdList), TASK_POLLING_INTERVAL);
                        }
                        return;
                    }
                    if (!Array.isArray(result)) {
                        // 处理数组类型的data
                        data = [result];
                    }
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i];
                        const { event_id: eventId, queue } = item;
                        const itemId = uploadImageList.find(image => image.eventId === eventId)?.id || '';
                        let currentQueue = 0;
                        let queueNumber = 0;
                        let imageStatusInfo = {};
                        switch (item.job_state) {
                            case 'succeeded':
                                if (item.out_put) {
                                    const list = item.out_put;
                                    const imageEnhancerCreationList = await FJUtil.parseList(list, {
                                        isUploadWaterMark: true,
                                    });
                                    const info = imageEnhancerCreationList[0];
                                    info.task_id = info.id;
                                    delete info.id;
                                    dispatch(
                                        FJActionImageEnhancer.updateCreationInfoById(itemId, {
                                            ...info,
                                            isLoading: false,
                                        }),
                                    );
                                }
                                if (isMobile) {
                                    // 移动端单张
                                    dispatch(setSliceTaskStatusAction(FJConstant.SUCCESS));
                                } else {
                                    setTimeout(() => {
                                        dispatch(
                                            FJActionImageEnhancer.updateImageInfoById(itemId, {
                                                taskStatus: FJConstant.DEFAULT,
                                            }),
                                        );
                                        setTimeout(() => {
                                            dispatch(FJActionImageEnhancer.deleteImageById(itemId));
                                        }, 1000);
                                    }, 2000);
                                }
                                imageStatusInfo = {
                                    taskStatus: FJConstant.SUCCESS,
                                };
                                f_eventIdList = f_eventIdList.filter(i => i !== eventId);
                                dispatch(FJActionCommon.updateHistoryListAction());

                                break;
                            case 'waiting':
                                if (queue) {
                                    currentQueue = queue?.current_queue || 0;
                                    queueNumber = queue?.queue_count || 0;
                                }
                                imageStatusInfo = {
                                    currentQueue,
                                    queueNumber,
                                    taskStatus: FJConstant.WAITING,
                                };

                                // 移动端单张
                                isMobile && dispatch(setSliceTaskStatusAction(FJConstant.WAITING));

                                break;
                            case 'processing':
                                imageStatusInfo = {
                                    taskStatus: FJConstant.GENERATING,
                                };
                                isMobile && dispatch(setSliceTaskStatusAction(FJConstant.GENERATING));
                                break;
                            case 'canceled':
                                if (!isMobile) {
                                    dispatch(FJActionImageEnhancer.deleteImageById(itemId));
                                    dispatch(FJActionImageEnhancer.deleteCreationById(itemId));
                                }
                                f_eventIdList = f_eventIdList.filter(i => i !== eventId);
                                FJUtil.updateAllCreditInfo(isFree);

                                break;
                            case 'failed':
                                imageStatusInfo = {
                                    taskStatus: FJConstant.DEFAULT,
                                };
                                if (!isMobile) {
                                    dispatch(FJActionImageEnhancer.deleteCreationById(itemId));
                                }
                                failTaskCount++;
                                f_eventIdList = f_eventIdList.filter(i => i !== eventId);
                                FJUtil.updateAllCreditInfo(isFree);
                                break;
                            default:
                                break;
                        }
                        dispatch(FJActionImageEnhancer.updateImageInfoById(itemId, imageStatusInfo));
                    }

                    timer = setTimeout(_request.bind(null), TASK_POLLING_INTERVAL);
                } catch (error) {
                    _error();
                }
            };
            timer = setTimeout(_request.bind(null, f_eventIdList), TASK_POLLING_INTERVAL);
        };
    },
    generateErrorAction: function () {
        return (dispatch, getState) => {
            // 删除上传列表成功元素  创作列表
            const { imageEnhancerCreationList, uploadImageList, selectCreationId } = getState().imageEnhancer;
            const newCreationList = imageEnhancerCreationList.filter(item => !item.isLoading);
            const newUploadImageList = uploadImageList
                .filter(item => item.taskStatus !== FJConstant.SUCCESS)
                .map(i => ({ ...i, taskStatus: FJConstant.DEFAULT }));

            let selectIdx = imageEnhancerCreationList.findIndex(i => i.id === selectCreationId);
            // 选中元素
            if (imageEnhancerCreationList[selectIdx]?.isLoading) {
                while (imageEnhancerCreationList[selectIdx]?.isLoading && selectIdx !== 0) {
                    selectIdx--;
                }
                const newSelectId = imageEnhancerCreationList[selectIdx]?.id || newCreationList[0]?.id || '';
                dispatch(setSliceSelectCreationIdAction(newSelectId));
            }
            // 更新列表
            dispatch(setSliceUploadImageListAction(newUploadImageList));
            dispatch(setSliceImageEnhancerCreationListAction(newCreationList));
        };
    },
    downloadAllAction: function () {
        return async (dispatch, getState) => {
            const { imageEnhancerCreationList } = getState().imageEnhancer;
            const urls = imageEnhancerCreationList.map(i => i.imgUrl);
            dispatch(setSliceBatchDownloadLoadingAction(true));
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool download click', { source: 'creation', tool });
            FJUtil.multiDownloadByUrls(urls, () => {
                dispatch(setSliceBatchDownloadLoadingAction(false));
            });
        };
    },
    loadImageEnhancerPageAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                let uploadFiles = [];
                if (fileList) {
                    for (let i = 0; i < fileList.length; i++) {
                        const fileInfo = fileList[i]?.info;
                        if (!fileInfo) continue;

                        const data = await FJLoadLocalforageStore.getItem(fileList[i].key);
                        const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                        uploadFiles.push(file);
                    }
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    blob.name = avator.split('/').reverse()[0];
                    uploadFiles.push(blob);
                }
                uploadFiles.length && dispatch(FJActionImageEnhancer.uploadImagesAction(uploadFiles));
            }
        };
    },
    // 移动端取消任务
    mobileCancelTaskAction: function () {
        return async dispatch => {
            try {
                f_eventIdList &&
                    f_eventIdList.length > 0 &&
                    (await Promise.all(
                        f_eventIdList.map(async eventId => {
                            await FJNetworkStore.cancelTask(eventId);
                        }),
                    ));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },
};
export default FJActionImageEnhancer;
